// @ts-nocheck

import React, { useState, useCallback, createRef, useEffect } from 'react';
import styled from 'styled-components';

import { KeyboardReturn, KeyboardClear, ChevronLeft } from '../../../assets/svg';
import { getDecimalSeparator, __ } from '../../../i18n/l10n';

import FastButton from './FastButton';

const Key = styled(FastButton)`
  && {
    width: 100%;
    height: 100%;
    padding: 0;
    font-size: 1.2em;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.6);
    color: #000;
    font-weight: 600;
    border-radius: 2px;
    cursor: pointer;

    /* Prevent the callout on tap-hold and text selection */
    user-select: none;
  }
`;

const KeyWrapper = styled.div`
  width: 33.33%;
  height: 3em;
  padding: 0.1em;
  box-sizing: border-box;
  float: left;
`;

const Keys = styled.div`
  padding: 0.1em;
  ::after {
    content: '';
    display: block;
    clear: both;
  }
`;

const Amount = styled.div`
  position: relative;
  line-height: 3em;
  height: 3em;
  padding-right: 1em;
  padding-left: 3em;
  text-align: right;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: inset 0 4px 4px rgba(0, 0, 0, 0.7);
`;

const PreviousButton = styled(FastButton)`
  && {
    position: relative;
    line-height: 1em;
    height: 3em;
    padding: 0 2em 0 0;
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

const KeyboardBackIcon = styled(ChevronLeft)`
  width: 3em;
  height: 1em;
`;

const AmountValue = styled.span`
  font-size: 1.6em;
  color: #fff;

  /* Prevent the callout on tap-hold and text selection */
  user-select: none;
`;

const ClearButton = styled(FastButton)`
  && {
    position: absolute;
    left: 0;
    top: 0;
    width: 3em;
    height: 3em;
    padding: 0;
    line-height: 0;
    text-align: center;
  }
`;

const KeyboardReturnIcon = styled(KeyboardReturn)`
  width: 1.2em;
  height: 1.2em;
  color: ${({ theme }) => theme.common.colors.primary};
`;

const KeyboardClearIcon = styled(KeyboardClear)`
  width: 1.2em;
  height: 1.2em;
  color: #000;
`;

const Keyboard = (props) => {
  const domItem = createRef();
  const { close, stake, onChange } = props;
  const [value, setValue] = useState(null);

  const onKeyPress = useCallback(
    (key) => () => {
      if (key === 'Enter') {
        close();
      } else {
        setValue((old) => (old ? `${old}${key}`.replace(/(,|\.)+/, '.') : String(key).replace(/(,|\.)+/, '.')));
      }
    },
    [close],
  );

  const onClear = useCallback(() => setValue(''), []);

  useEffect(() => {
    if (value !== null) {
      onChange(value);
    }
  }, [onChange, value]);

  const getReadableKey = (key) => {
    if (key === 'Enter') {
      return <KeyboardReturnIcon />;
    }
    return key;
  };

  return (
    <div ref={domItem}>
      <PreviousButton onClick={close}>
        <KeyboardBackIcon /> {__('Wager')}
      </PreviousButton>
      <Amount>
        <ClearButton onClick={onClear}>
          <KeyboardClearIcon />
        </ClearButton>
        <AmountValue>{stake || stake === 0 ? String(stake).replace('.', getDecimalSeparator()) : null}</AmountValue>
      </Amount>
      <Keys>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, getDecimalSeparator(), 0, 'Enter'].map((key) => (
          <KeyWrapper key={key}>
            <Key onClick={onKeyPress(key)}>{getReadableKey(key)}</Key>
          </KeyWrapper>
        ))}
      </Keys>
    </div>
  );
};

export default Keyboard;
